// extracted by mini-css-extract-plugin
export var callCard = "_p3-0";
export var callMessageButton = "_p3-1";
export var helpIcon = "_p3-3";
export var helpIconContainer = "_p3-4";
export var verticalDivider = "_p3-2";